import { createEvent } from '@cobuildlab/react-simple-state';
import { LanguageType } from '../../shared/types';

export const OnLanguageTypes = createEvent<LanguageType[]>();
export const OnLanguageTypesError = createEvent();
